// extracted by mini-css-extract-plugin
export default {"card":"LoyaltyProgramServiceCard_card__JuGZv","cardList":"LoyaltyProgramServiceCard_cardList__AE-61","img":"LoyaltyProgramServiceCard_img__Lgoge"};